import React from "react";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Status, { STATUS_DISPLAY, STATUS_TYPE } from "@acadia-ui/status";

/*
	Mappings last provided by Otto Lam & Jessica Stuart on 5/18/2022
	Code(s)  DB Status                   UI Status
	1        Not Synced                  Draft
	2        Attempted Sync              Failed
	3        Synced                      Success
	4        Sent to Queue               Processing
	5        Not eligible for syncing    To Do
	6        Edit                        Revision Needed
*/

const getStatusMapping = (status) => {
	let title;
	let type;
	switch (status) {
		case 1:
			title = "Draft";
			type = STATUS_TYPE.DRAFT;
			break;
		case 2:
			title = "Failed";
			type = STATUS_TYPE.FAILED;
			break;
		case 3:
			title = "Success";
			type = STATUS_TYPE.SUCCESS;
			break;
		case 4:
			title = "Processing";
			type = STATUS_TYPE.PROCESSING;
			break;
		case 5:
			title = "To Do";
			type = STATUS_TYPE.TODO;
			break;
		case 6:
			title = "Revision Needed";
			type = STATUS_TYPE.REVISIONNEEDED;
			break;
		default:
			console.log(`invalid status code provided of: ${status}`);
	}

	return { title, type };
};

export const PlatformStatusIcon = ({ status, tooltip, isBadge = true, position = TOOLTIP_POSITION.AUTO }) => {
	const { title, type } = getStatusMapping(status);
	return title ? (
		<Tooltip title={tooltip} position={position}>
			<Status
				// this comment exists to prevent eslint from making this unreadable.
				type={type}
				title={title}
				display={isBadge ? STATUS_DISPLAY.ICON_ONLY : STATUS_DISPLAY.DEFAULT}
			/>
		</Tooltip>
	) : (
		<></>
	);
};
